import React from 'react';
import { Box, Divider } from '@mui/material';
import { MessagingToDoStatus } from '@uplift/api';
import { ScrollableView } from '../../Layout';
import { useMessagingToDoQuery } from '@uplift/queries';
import { Loader } from '../../Loader';
import { ArrowBack } from '@mui/icons-material';
import { ToDoContent } from './ToDoContent.component';
import { MessagingToDosFilterMenu, MessagingToDosList } from './ToDosList.component';
import { DialogActionButton, MessagingDialogTitle } from '../MessagingModal/DesktopMessagingDialog';
import { useMessagingContext } from '../MessagingProvider.component';


export const DesktopMessagingToDosContent: React.FC<{ onBack: () => void }> = (props) => {
  const [ statusFilter, setStatusFilter ] = React.useState<MessagingToDoStatus>('active');
  const { selectedToDoId, setSelectedToDoId } = useMessagingContext();
  const { data: selectedToDo } = useMessagingToDoQuery(selectedToDoId, { enabled: !!selectedToDoId });

  return (
    <>
      <MessagingDialogTitle
        title="To Dos"
        actions={(
          <DialogActionButton onClick={props.onBack} Icon={ArrowBack}>
            Back to Messages
          </DialogActionButton>
        )}
      />
      <Divider />
      <Box display="flex" height="100%" width="100%">
        <Box flex={1} maxWidth="360px">
          <Box display="flex" flexDirection="column" height="100%">
            <Box>
              <MessagingToDosFilterMenu value={statusFilter} onChange={setStatusFilter} />
            </Box>
            <ScrollableView width="100%" flex={1}>
              <React.Suspense fallback={<Loader height="100%" width="100%" />}>
                <MessagingToDosList
                  status={statusFilter}
                  selectedToDoId={selectedToDoId}
                  setSelectedToDoId={setSelectedToDoId}
                />
              </React.Suspense>
            </ScrollableView>
          </Box>
        </Box>
        <Divider orientation="vertical" />
        {selectedToDo && <ToDoContent todo={selectedToDo} />}
      </Box>
    </>
  );
};


export const MobileMessagingToDosContent: React.FC<{ onBack: () => void }> = (props) => {
  const [ statusFilter, setStatusFilter ] = React.useState<MessagingToDoStatus>('active');
  const { selectedToDoId, setSelectedToDoId } = useMessagingContext();
  const { data: selectedToDo } = useMessagingToDoQuery(selectedToDoId, { enabled: !!selectedToDoId });

  return (
    <>
      <MessagingDialogTitle
        title="To Dos"
        actions={selectedToDo ? (
          <DialogActionButton onClick={() => setSelectedToDoId(undefined)} Icon={ArrowBack}>
            Back to list
          </DialogActionButton>
        ) : (
          <DialogActionButton onClick={props.onBack} Icon={ArrowBack}>
            Back
          </DialogActionButton>
        )}
      />
      <Divider />
      {selectedToDo ? (
        <ToDoContent todo={selectedToDo} />
      ) : (
        <Box display="flex" flexDirection="column" height="100%">
          <Box>
            <MessagingToDosFilterMenu value={statusFilter} onChange={setStatusFilter} />
          </Box>
          <ScrollableView width="100%" flex={1}>
            <React.Suspense fallback={<Loader height="100%" width="100%" />}>
              <MessagingToDosList
                status={statusFilter}
                selectedToDoId={selectedToDoId}
                setSelectedToDoId={setSelectedToDoId}
              />
            </React.Suspense>
          </ScrollableView>
        </Box>
      )}
    </>
  );
};
